import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

const translations = {
  ar: {
    // Landing Page
    appName: 'B2B Market Iraq',
    login: 'تسجيل الدخول',
    register: 'انضم لنا',
    heroTitle: 'منصة B2B الرائدة لعروض الشركات',
    heroSubtitle: 'اعرض منتجاتك وخدماتك أو ابحث عما تحتاجه في منصة واحدة متخصصة للشركات',
    getStarted: 'ابدأ الآن',
    browseOffers: 'تصفح العروض',
    features: 'المميزات',
    whyChooseUs: 'لماذا تختار مركز البائعين؟',
    saleOffers: 'عروض البيع',
    saleOffersDesc: 'اعرض منتجاتك وخدماتك بسهولة واصل إلى آلاف الشركات الباحثة عن عروض مميزة',
    purchaseRequests: 'طلبات الشراء',
    purchaseRequestsDesc: 'انشر طلباتك ودع الشركات تتقدم بعروضها لتلبية احتياجاتك',
    directMessaging: 'تواصل مباشر',
    directMessagingDesc: 'نظام رسائل آمن للتواصل مع الشركات وإتمام الصفقات',
    trustQuality: 'موثوقية وجودة',
    trustQualityDesc: 'نظام تقييم ومراجعات للشركات مع موافقة إدارية على جميع العروض',
    registeredCompanies: 'شركة مسجلة',
    activeOffers: 'عرض نشط',
    completedDeals: 'صفقة مكتملة',
    joinThousands: 'انضم لآلاف الشركات الآن',
    startPosting: 'ابدأ بنشر عروضك أو البحث عن ما تحتاجه في دقائق',
    registerFree: 'سجل مجاناً',
    allRightsReserved: 'جميع الحقوق محفوظة',
    marketplace: 'السوق',
    
    // Auth Pages
    welcomeBack: 'مرحباً بعودتك',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    noAccount: 'ليس لديك حساب؟',
    registerNow: 'سجل الآن',
    haveAccount: 'لديك حساب بالفعل؟',
    createNewAccount: 'إنشاء حساب جديد',
    joinBiggestPlatform: 'انضم إلى أكبر منصة B2B',
    fullName: 'الاسم الكامل',
    companyName: 'اسم الشركة',
    companyDescription: 'وصف الشركة',
    phone: 'رقم الهاتف',
    phoneOptional: 'رقم الهاتف (اختياري)',
    address: 'العنوان',
    addressOptional: 'العنوان (اختياري)',
    country: 'الدولة',
    selectCountry: 'اختر الدولة',
    sendOtp: 'إرسال رمز التحقق',
    verifyOtp: 'تحقق',
    otpSent: 'تم إرسال رمز التحقق عبر واتساب',
    otpVerified: 'تم التحقق من رقم الهاتف بنجاح',
    otpInvalid: 'رمز التحقق غير صحيح أو منتهي الصلاحية',
    otpFailed: 'فشل إرسال رمز التحقق عبر واتساب. تحقق من صيغة الرقم',
    enterOtp: 'أدخل رمز التحقق',
    phoneRequired: 'رقم الهاتف مطلوب',
    phoneVerified: 'تم التحقق',
    resendOtp: 'إعادة الإرسال',
    createAccount: 'إنشاء الحساب',
    loggingIn: 'جاري تسجيل الدخول...',
    registering: 'جاري التسجيل...',
    
    // Dashboard
    dashboard: 'لوحة التحكم',
    welcome: 'مرحباً',
    messages: 'الرسائل',
    logout: 'تسجيل الخروج',
    accountPending: 'حسابك قيد المراجعة',
    accountPendingDesc: 'شكراً للتسجيل! حسابك قيد المراجعة من قبل الإدارة. ستتمكن من نشر العروض والطلبات بعد الموافقة.',
    accountRejected: 'تم رفض الحساب',
    accountRejectedDesc: 'نأسف، تم رفض طلب تفعيل حسابك. يرجى التواصل مع الإدارة للمزيد من المعلومات.',
    myOffers: 'عروض البيع الخاصة بك',
    myRequests: 'طلبات الشراء الخاصة بك',
    noOffers: 'لا توجد عروض بعد',
    noRequests: 'لا توجد طلبات بعد',
    createOffer: 'إنشاء عرض بيع',
    createOfferDesc: 'اعرض منتجاتك وخدماتك للشركات الأخرى',
    createRequest: 'إنشاء طلب شراء',
    createRequestDesc: 'انشر طلبك واحصل على عروض من الشركات',
    quantity: 'الكمية',
    price: 'السعر',
    budget: 'الميزانية',
    status: 'الحالة',
    pending: 'قيد المراجعة',
    approved: 'مقبول',
    rejected: 'مرفوض',
    totalOffers: 'عروض البيع',
    totalRequests: 'طلبات الشراء',
    approvedItems: 'مقبولة',
    pendingItems: 'قيد المراجعة',
    backToDashboard: 'العودة للوحة التحكم',
    
    // Marketplace
    searchPlaceholder: 'ابحث عن منتج أو خدمة...',
    allCategories: 'جميع الفئات',
    filter: 'تصفية',
    search: 'بحث',
    offersTab: 'عروض البيع',
    requestsTab: 'طلبات الشراء',
    noResults: 'لا توجد نتائج',
    browseMarketplace: 'تصفح العروض والطلبات من الشركات',
    
    // Create Offer/Request
    createNewOffer: 'إنشاء عرض بيع جديد',
    createNewRequest: 'إنشاء طلب شراء جديد',
    fillOfferDetails: 'املأ البيانات لإضافة عرضك إلى السوق',
    fillRequestDetails: 'املأ البيانات لإضافة طلبك إلى السوق',
    offerTitle: 'عنوان العرض',
    requestTitle: 'عنوان الطلب',
    description: 'الوصف',
    category: 'الفئة',
    selectCategory: 'اختر الفئة',
    expirationDate: 'تاريخ الانتهاء',
    expirationOptional: 'تاريخ الانتهاء (اختياري)',
    creating: 'جاري الإنشاء...',
    offerTitlePlaceholder: 'مثال: خدمات تطوير البرمجيات',
    requestTitlePlaceholder: 'مثال: نبحث عن خدمات تسويق رقمي',
    descriptionPlaceholder: 'اكتب وصفاً تفصيلياً...',
    addImage: 'إضافة صورة',
    changeImage: 'تغيير الصورة',
    removeImage: 'حذف الصورة',
    imageOptional: 'صورة المنتج (اختياري)',
    uploading: 'جاري الرفع...',
    imageUploadError: 'حدث خطأ أثناء رفع الصورة',
    maxFileSize: 'الحد الأقصى لحجم الملف 5 ميجابايت',
    
    // Messages
    messagingSystem: 'نظام المراسلة',
    communicateWithCompanies: 'تواصل مع الشركات الأخرى',
    inboxMessages: 'الرسائل الواردة',
    sentMessages: 'الرسائل المرسلة',
    noInboxMessages: 'لا توجد رسائل واردة',
    noSentMessages: 'لا توجد رسائل مرسلة',
    newMessage: 'جديد',
    
    // Admin Dashboard
    adminDashboard: 'لوحة الإدارة',
    manageCompaniesOffersRequests: 'إدارة الشركات والعروض والطلبات',
    companies: 'الشركات',
    adminDescription: 'إدارة الشركات والعروض والطلبات والرسائل من مكان واحد',
    pendingCompanies: 'شركات قيد المراجعة',
    pendingOffers: 'عروض قيد المراجعة',
    pendingRequests: 'طلبات قيد المراجعة',
    companiesTab: 'الشركات',
    accept: 'قبول',
    reject: 'رفض',
    edit: 'تعديل',
    suspend: 'توقيف',
    activate: 'تفعيل',
    suspended: 'موقوفة',
    editCompany: 'تعديل معلومات الشركة',
    updateCompany: 'تحديث الشركة',
    companyUpdated: 'تم تحديث معلومات الشركة بنجاح',
    companySuspended: 'تم توقيف الشركة بنجاح',
    companyActivated: 'تم تفعيل الشركة بنجاح',
    searchCompanies: 'بحث في الشركات...',
    searchOffers: 'بحث في العروض...',
    searchRequests: 'بحث في الطلبات...',
    companyEmail: 'البريد الإلكتروني',
    offerId: 'رقم العرض',
    requestId: 'رقم الطلب',
    
    // Common
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    close: 'إغلاق',
    submit: 'إرسال',
    back: 'رجوع',
    confirmDeleteOffer: 'هل أنت متأكد من حذف هذا العرض؟',
    confirmDeleteRequest: 'هل أنت متأكد من حذف هذا الطلب؟',
    offerDeleted: 'تم حذف العرض بنجاح',
    requestDeleted: 'تم حذف الطلب بنجاح',
    offerUpdated: 'تم تحديث العرض بنجاح',
    requestUpdated: 'تم تحديث الطلب بنجاح',
    editOffer: 'تعديل العرض',
    editRequest: 'تعديل الطلب'
  },
  en: {
    // Landing Page
    appName: 'B2B Market Iraq',
    login: 'Login',
    register: 'Join Us',
    heroTitle: 'Leading B2B Platform for Company Offers',
    heroSubtitle: 'Showcase your products and services or find what you need in one specialized platform for businesses',
    getStarted: 'Get Started',
    browseOffers: 'Browse Offers',
    features: 'Features',
    whyChooseUs: 'Why Choose B2B Market Iraq?',
    saleOffers: 'Sale Offers',
    saleOffersDesc: 'Easily showcase your products and services and reach thousands of companies looking for quality offers',
    purchaseRequests: 'Purchase Requests',
    purchaseRequestsDesc: 'Post your requests and let companies submit their offers to meet your needs',
    directMessaging: 'Direct Messaging',
    directMessagingDesc: 'Secure messaging system to communicate with companies and complete deals',
    trustQuality: 'Trust & Quality',
    trustQualityDesc: 'Company rating and review system with admin approval on all offers',
    registeredCompanies: 'Registered Companies',
    activeOffers: 'Active Offers',
    completedDeals: 'Completed Deals',
    joinThousands: 'Join Thousands of Companies Now',
    startPosting: 'Start posting your offers or searching for what you need in minutes',
    registerFree: 'Register Free',
    allRightsReserved: 'All rights reserved',
    marketplace: 'Marketplace',
    
    // Auth Pages
    welcomeBack: 'Welcome Back',
    email: 'Email',
    password: 'Password',
    noAccount: "Don't have an account?",
    registerNow: 'Register Now',
    haveAccount: 'Already have an account?',
    createNewAccount: 'Create New Account',
    joinBiggestPlatform: 'Join the Biggest B2B Platform',
    fullName: 'Full Name',
    companyName: 'Company Name',
    companyDescription: 'Company Description',
    phone: 'Phone',
    phoneOptional: 'Phone (Optional)',
    address: 'Address',
    addressOptional: 'Address (Optional)',
    country: 'Country',
    selectCountry: 'Select Country',
    sendOtp: 'Send OTP',
    verifyOtp: 'Verify',
    otpSent: 'Verification code sent via WhatsApp',
    otpVerified: 'Phone number verified successfully',
    otpInvalid: 'Invalid or expired verification code',
    otpFailed: 'Failed to send WhatsApp OTP. Check phone number format',
    enterOtp: 'Enter verification code',
    phoneRequired: 'Phone number is required',
    phoneVerified: 'Verified',
    resendOtp: 'Resend',
    createAccount: 'Create Account',
    loggingIn: 'Logging in...',
    registering: 'Registering...',
    
    // Dashboard
    dashboard: 'Dashboard',
    welcome: 'Welcome',
    messages: 'Messages',
    logout: 'Logout',
    accountPending: 'Your Account is Under Review',
    accountPendingDesc: 'Thank you for registering! Your account is under review by our team. You will be able to post offers and requests after approval.',
    accountRejected: 'Account Rejected',
    accountRejectedDesc: 'Sorry, your account activation request has been rejected. Please contact admin for more information.',
    myOffers: 'My Sale Offers',
    myRequests: 'My Purchase Requests',
    noOffers: 'No offers yet',
    noRequests: 'No requests yet',
    createOffer: 'Create Sale Offer',
    createOfferDesc: 'Showcase your products and services to other companies',
    createRequest: 'Create Purchase Request',
    createRequestDesc: 'Post your request and get offers from companies',
    quantity: 'Quantity',
    price: 'Price',
    budget: 'Budget',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    totalOffers: 'Sale Offers',
    totalRequests: 'Purchase Requests',
    approvedItems: 'Approved',
    pendingItems: 'Pending Review',
    backToDashboard: 'Back to Dashboard',
    
    // Marketplace
    searchPlaceholder: 'Search for product or service...',
    allCategories: 'All Categories',
    filter: 'Filter',
    search: 'Search',
    offersTab: 'Sale Offers',
    requestsTab: 'Purchase Requests',
    noResults: 'No results found',
    browseMarketplace: 'Browse offers and requests from companies',
    
    // Create Offer/Request
    createNewOffer: 'Create New Sale Offer',
    createNewRequest: 'Create New Purchase Request',
    fillOfferDetails: 'Fill in the details to add your offer to the marketplace',
    fillRequestDetails: 'Fill in the details to add your request to the marketplace',
    offerTitle: 'Offer Title',
    requestTitle: 'Request Title',
    description: 'Description',
    category: 'Category',
    selectCategory: 'Select Category',
    expirationDate: 'Expiration Date',
    expirationOptional: 'Expiration Date (Optional)',
    creating: 'Creating...',
    offerTitlePlaceholder: 'Example: Software Development Services',
    requestTitlePlaceholder: 'Example: Looking for Digital Marketing Services',
    descriptionPlaceholder: 'Write a detailed description...',
    addImage: 'Add Image',
    changeImage: 'Change Image',
    removeImage: 'Remove Image',
    imageOptional: 'Product Image (Optional)',
    uploading: 'Uploading...',
    imageUploadError: 'Error uploading image',
    maxFileSize: 'Max file size 5MB',
    
    // Messages
    messagingSystem: 'Messaging System',
    communicateWithCompanies: 'Communicate with other companies',
    inboxMessages: 'Inbox Messages',
    sentMessages: 'Sent Messages',
    noInboxMessages: 'No inbox messages',
    noSentMessages: 'No sent messages',
    newMessage: 'New',
    
    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    manageCompaniesOffersRequests: 'Manage companies, offers, and requests',
    companies: 'Companies',
    adminDescription: 'Manage companies, offers, requests and messages from one place',
    pendingCompanies: 'Companies Under Review',
    pendingOffers: 'Offers Under Review',
    pendingRequests: 'Requests Under Review',
    companiesTab: 'Companies',
    accept: 'Accept',
    reject: 'Reject',
    edit: 'Edit',
    suspend: 'Suspend',
    activate: 'Activate',
    suspended: 'Suspended',
    editCompany: 'Edit Company Information',
    updateCompany: 'Update Company',
    companyUpdated: 'Company information updated successfully',
    companySuspended: 'Company suspended successfully',
    companyActivated: 'Company activated successfully',
    searchCompanies: 'Search companies...',
    searchOffers: 'Search offers...',
    searchRequests: 'Search requests...',
    companyEmail: 'Email',
    offerId: 'Offer ID',
    requestId: 'Request ID',
    
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    close: 'Close',
    submit: 'Submit',
    back: 'Back',
    confirmDeleteOffer: 'Are you sure you want to delete this offer?',
    confirmDeleteRequest: 'Are you sure you want to delete this request?',
    offerDeleted: 'Offer deleted successfully',
    requestDeleted: 'Request deleted successfully',
    offerUpdated: 'Offer updated successfully',
    requestUpdated: 'Request updated successfully',
    editOffer: 'Edit Offer',
    editRequest: 'Edit Request'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ar');
  const [direction, setDirection] = useState('rtl');

  useEffect(() => {
    // Load saved language from localStorage
    const savedLang = localStorage.getItem('language') || 'ar';
    setLanguage(savedLang);
    setDirection(savedLang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = savedLang;
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'ar' ? 'en' : 'ar';
    setLanguage(newLang);
    setDirection(newLang === 'ar' ? 'rtl' : 'ltr');
    localStorage.setItem('language', newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, direction, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};